import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

let socketInstance = null;

export function useSocket(token) {
  const socketRef = useRef(null);

  useEffect(() => {
    if (!token) return;

    if (!socketInstance || !socketInstance.connected) {
      if (socketInstance) {
        socketInstance.disconnect();
        socketInstance = null;
      }
      socketInstance = io(import.meta.env.VITE_WS_URL || '/', {
        auth: { token },
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 20000,
      });

      socketInstance.on('connect', () => {
        console.log('Socket conectado:', socketInstance.id);
      });

      socketInstance.on('disconnect', (reason) => {
        console.log('Socket desconectado:', reason);
      });

      socketInstance.on('connect_error', (err) => {
        console.log('Erro de conexão socket:', err.message);
      });
    }

    socketRef.current = socketInstance;
    return () => {};
  }, [token]);

  return socketRef;
}

export function getSocket() {
  return socketInstance;
}
